var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "has-logo": true } },
    [
      _c("logo", { attrs: { collapse: _vm.isCollapse } }),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "unique-opened": false,
                "collapse-transition": false,
                mode: "vertical",
                "active-text-color:-409e-f-f-": "",
              },
            },
            _vm._l(_vm.menus, function (menu) {
              return _c("sidebar-item", {
                key: menu.code,
                attrs: { item: menu, "base-path": menu.name },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }